import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Box, Icon, Columns, Form, Button, Disclosure, Input, Level, Toasts, Notification } from '@deseretbook/react-ui'
import PaymentSourceDetails from './PaymentSourceDetails'
import { withCheckout } from '../CheckoutContext'
import GiftCardForm from './GiftCardForm'
import AppliedGiftCard from './AppliedGiftCard'


/**
 * Checkout payment method for processing gift card and promo codes.
 */
const GiftCardPaymentMethod = ({ order, status, availablePaymentMethods }) => {
  const giftCardsAreProcessable = status && status.services && status.services.relate
  const giftCardPaymentMethod = availablePaymentMethods
    .filter(({ type }) => type === 'DeseretBook::PaymentMethod::GiftCard')[0]

  return (
    <Fragment>
      {/* Display a warning if we think our gift card processing service is having issues. */}
      {
        giftCardPaymentMethod && !giftCardsAreProcessable
          ? (
            <Notification
              type="warning"
              titleContent="Unable to Process Gift Cards"
            >
              Sorry! It looks like we're having troubles processing gift cards
              right now. If you're unable to apply your gift card, please refresh
              the page or try again in a little bit.
            </Notification>
          )
          : null
      }

      {/* Show all the applied gift cards so users can remove applied ones if they want. */}
      {
        order.payments
          .filter(({ state, sourceType }) => state === 'checkout' && sourceType === 'DeseretBook::GiftCard')
          .map(payment => (
            <Box paddingBottom={0.5} key={payment.source.id}>
              <AppliedGiftCard payment={payment} />
            </Box>
          ))
      }

      {/* Show the actual form */}
      <GiftCardForm paymentMethod={giftCardPaymentMethod} />
    </Fragment>
  )
}

GiftCardPaymentMethod.propTypes = {
  /** Current order */
  order: PropTypes.object, // private
  /** Current page status */
  status: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.objectOf(PropTypes.bool),
  ])), // private
  /** Available payment method types */
  availablePaymentMethods: PropTypes.array,
}

GiftCardPaymentMethod.defaultProps = {
  order: {},
  status: {},
  availablePaymentMethods: [],
}

export default withCheckout(GiftCardPaymentMethod)
